
export class ServerUrls {
    static baseRestApiURL = "/api/v1/";
    static baseResourceURL = "/resources/";
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/classes/ServerUrls.ts